export default class Money {
    constructor(props) {
        Object.assign(this, props);
        if (props.disabled_at) {
            this.disabled_at = new Date(props.disabled_at);
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Moneys/Money.ts
// module id = 156
// module chunks = 0